(function () {
  // Require jQuery + Timber
  if (!window.jQuery || !window.timber) return;
  var $ = jQuery;

  // Your nav drawer element must be: <div id="NavDrawer" class="drawer drawer--right"></div>

  // A robust set of selectors that commonly identify the hamburger that should open Nav
  // Add/remove entries as needed to match your theme's markup.

  // Create a dedicated Timber drawer for NAV on the RIGHT, with a UNIQUE open selector.
  // This avoids sharing the generic ".js-drawer-open-button-right" hook with cart/SmartCart.
  try {
    // If already constructed elsewhere, this will just rebind the open selector to NAV_TOGGLER
    window.timber.NavDrawer = new window.timber.Drawers('NavDrawer', 'right', {
      open: '.js-nav-toggle, [aria-controls="NavDrawer"], a[href="#NavDrawer"], button[data-drawer-id="NavDrawer"]'
    });
  } catch (e) {
    // If theme guarded Drawers construction, fail gracefully
    console.warn('NavDrawer init warning:', e);
  }

  // Intercept hamburger clicks in the CAPTURE phase so Rebuy can't hijack them
  document.addEventListener('click', function (e) {
    console.log(e.target, 'e.target')

  try {
    if (typeof NAV_TOGGLER !== 'undefined' && NAV_TOGGLER) {
      var btn = e.target.closest(NAV_TOGGLER);
          if (!btn) return;

          // This click is for the NAV drawer—stop others (like Rebuy) from handling it
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

          // Open the Timber Nav drawer
          if (window.timber && window.timber.NavDrawer && typeof window.timber.NavDrawer.open === 'function') {
            window.timber.NavDrawer.open(e);
      }
    }
  } catch (err) {
    console.warn('Nav toggler not initialized:', err);
  }

    
    
  }, true); // <-- capture

  // Optional hardening: if your hamburger ALSO has the generic right-open class,
  // stop it from triggering any other "right drawer" handlers.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-drawer-open-button-right');
    if (!btn) return;

    // If the button is actually our Nav toggler, swallow it here too.
    if (btn.matches(NAV_TOGGLER)) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }
  }, true);

  // Sanity helper: ensure #NavDrawer is marked as right drawer for CSS
  var nav = document.getElementById('NavDrawer');
  if (nav && !nav.classList.contains('drawer--right')) {
    nav.classList.add('drawer--right');
  }
})();